import { Country, CurrenciesState } from '@spartacus/core'

export const MB_SITE_CONTEXT_FEATURE = 'mbSiteContext'

export interface MbStateWithSiteContext {
  [MB_SITE_CONTEXT_FEATURE]: MbSiteContextState;
}

export interface MbSiteContextState {
  countries: CountriesState;
  currencies: CurrenciesState;
}

export interface CountriesState {
  entities: CountriesEntities;
  activeCountry: string;
}

export interface CountriesEntities {
  [isocode: string]: Country;
}
